export default __webpack_public_path__ + "static/media/ieee.d13ca181.svg";